import { Component, Inject } from '@angular/core';
import { DwComponent, DwComponentType, DwEventService, DwExpressionService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';
import { CourseRepositoryService } from '../../../services/course-repository.service';
import { CourseStudentProgressFormCardComponent } from '../course-student-progress-form-card/course-student-progress-form-card.component';


@DwComponent({
  key: 'courseStudentProgressSummaryFormCard',
  name: 'Course Student Progress Card - Form Summary',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.StudentCourse,
  isGlobal: false,
})
@Component({
  selector: 'app-course-student-progress-summary-form-card',
  template: `
    <div class="progress-list course-progress-list course-progress-summary-list">
      <app-course-student-progress-summary-card [data]="studentCourseProgress"></app-course-student-progress-summary-card>
    </div>
  `
})
export class CourseStudentProgressSummaryFormCardComponent extends CourseStudentProgressFormCardComponent {

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormStateService: DwMetaDataFormStateService,
    courseRepositoryService: CourseRepositoryService,
    dwEventService: DwEventService,
  ) {
    super(
      dwExpressionService,
      dwUiConfigRegistryService,
      uiMetaDataConfig,
      dwMetaDataService,
      dwFormStateService,
      courseRepositoryService,
      dwEventService
    );
  }

}
